{
  "version": 1,
  "asset_id": "323cded9-c55a-4506-9cae-d1641380147d",
  "project_id": "81864b6f-53ca-42c2-811b-21ffcbfd0515",
  "url": "/__l5e/assets-v1/323cded9-c55a-4506-9cae-d1641380147d/elka-watch.webp",
  "r2_key": "a/v1/81864b6f-53ca-42c2-811b-21ffcbfd0515/323cded9-c55a-4506-9cae-d1641380147d/elka-watch.webp",
  "original_filename": "elka-watch.webp",
  "size": 124634,
  "content_type": "image/webp",
  "created_at": "2026-07-13T07:04:17Z"
}
